import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UserInfo } from '../../../models/user-info.model';
import { GraphService } from 'src/app/services/graph/graph.service';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/services/users/users.service';
import { SharemailboxDeleteConfirmComponent } from './sharemailbox-delete-confirm/sharemailbox-delete-confirm.component';
import { entAnimations } from 'src/app/animations';
import { lastValueFrom, Subscription } from 'rxjs';
import { Error } from 'src/app/models/error.model';
import { SharedServiceMailBox } from 'src/app/services/sharemailbox/sharemailbox.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { SharemailboxAddDialogComponent } from './sharemailbox-add-dialog/sharemailbox-add-dialog.component';
import { ExchangeListFields } from 'src/app/models/resource-list-fields.model';
import { ToolBoxService } from 'src/app/services/toolbox/toolbox.service';

@Component({
  selector: 'app-sharemailbox',
  templateUrl: './sharemailbox.component.html',
  styleUrls: ['./sharemailbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class SharemailboxComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  SharedmailboxAddDialogComponent = SharemailboxAddDialogComponent;
  SharedmailboxDeleteConfirmComponent = SharemailboxDeleteConfirmComponent;

  private subscription: Subscription = new Subscription();

  isLoading = false;
  private readonly currentUser: UserInfo;
  hasNoSharemailbox = false;
  errorGetSharemailbox: Error = { error: { message: '', code: '' } };
  isErrorGetSharemailbox = false;
  sharemailboxlist: ExchangeListFields[];
  selectedEtablissement: string;
  dataSource: MatTableDataSource<ExchangeListFields>;
  disabledForMaintenance = false;
  isSharedmailboxDisabled = false;

  defaultColumns: string[] = [
    'state',
    'displayName',
    'email',
    'edit',
    'delete',
  ];
  hiddenColumns: string[] = [];
  displayedColumns: string[] = [...this.defaultColumns];
  windowWidth: number = window.innerWidth;

  constructor(
    private _router: Router,
    private _settingsService: SettingsService,
    private _graphService: GraphService,
    private _userService: UsersService,
    private _sharedService: SharedServiceMailBox,
    private _localStorageService: LocalStorageService,
    private _toolboxService: ToolBoxService
  ) {
    this.currentUser = this._userService.currentUserValue;
  }

  async ngOnInit(): Promise<void> {
    this.subscription.add(
      this._settingsService.currentGE$.subscribe(ge => {
        this.selectedEtablissement = ge;
        this.onEtablissementChange();
      })
    );
    this.selectedEtablissement = await this._toolboxService.getUserEtablissement();

    setTimeout(() => {
      this.getListOfSharemailbox();
      this.updateDisplayedColumns();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.windowWidth = window.innerWidth;
    this.updateDisplayedColumns();
  }

  private updateDisplayedColumns(): void {
    this.displayedColumns = [...this.defaultColumns];
    this.hiddenColumns = [];

    if (this.windowWidth < 950) {
      this._toolboxService.hideTableColumn(
        'edit',
        this.displayedColumns,
        this.hiddenColumns
      );
    }

    if (this.windowWidth < 850) {
      this._toolboxService.hideTableColumn(
        'delete',
        this.displayedColumns,
        this.hiddenColumns
      );
    }

    if (this.windowWidth < 750) {
      this._toolboxService.hideTableColumn(
        'email',
        this.displayedColumns,
        this.hiddenColumns
      );
    }

    if (this.windowWidth < 500) {
      this._toolboxService.hideTableColumn(
        'state',
        this.displayedColumns,
        this.hiddenColumns
      );
    }
  }
  private onEtablissementChange() {
    this._localStorageService.removeItem('myUsers'); // reset values when changing etab
    this._localStorageService.removeItem('UsersSharemailbox');
    this._localStorageService.removeItem('contextStorageUsersMailbox');
    this._sharedService.changeBoolean(true);
    this.getListOfSharemailbox();
  }

  async getListOfSharemailbox(): Promise<void> {
    try {
      if (this.selectedEtablissement) {
        this.hasNoSharemailbox = false;
        this.isLoading = true;
        this.errorGetSharemailbox = { error: { message: '', code: '' } };
        this.isErrorGetSharemailbox = false;

        this.sharemailboxlist = await lastValueFrom(
          this._graphService.getListSharemailbox(this.selectedEtablissement)
        );
        if (this.sharemailboxlist.length == 0) {
          this.hasNoSharemailbox = true;
        }
        this.isLoading = false;

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(this.sharemailboxlist);
          this.dataSource.paginator = this.paginator;
        });
      }
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (customError.error !== undefined) {
          if (customError.error.code == 'ERR403') {
            this._router.navigate(['/errors/error-403']);
          } else {
            this._router.navigate(['/errors/error-404']);
          }
        }
      }
      this.isLoading = false;
      this.errorGetSharemailbox = customError;
      this.isErrorGetSharemailbox = true;
    }
  }
}
